import { z } from 'zod';
import type { BaseParameterDetailAddition, BaseSqlDetailAddition } from '../types';
import { nullishAsUndefined, nullishToEmpty } from './utils';

export const sqlDetailSchema = z.object({
  normalizedQueryHash: z
    .string({ required_error: 'Normalized Query Hash' })
    .min(1, 'Normalized Query Hash'),
  instanceId: z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
  fromTime: nullishAsUndefined(z.string().optional()),
  toTime: nullishAsUndefined(z.string().optional()),
  xmSqlId: nullishAsUndefined(z.string().optional()),
  user: nullishAsUndefined(z.string().optional()),
  currentDatabase: nullishAsUndefined(z.string().optional()),
  hostname: nullishAsUndefined(z.string().optional()),
});

export const parameterDetailSchema = z
  .object({
    instanceId: z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
    name: nullishAsUndefined(z.string().optional()),
    parameterName: nullishAsUndefined(z.string().optional()),
    fromTime: nullishAsUndefined(z.string().optional()),
    toTime: nullishAsUndefined(z.string().optional()),
  })
  .transform(({ name, parameterName, ...rest }) => ({
    ...rest,
    parameterName: name ?? parameterName,
  }))
  .pipe(
    z.object({
      parameterName: z.string({ required_error: 'Parameter Name' }).min(1, 'Parameter Name'),
      instanceId: z.string().min(1, 'Instance ID'),
      fromTime: z.string().optional(),
      toTime: z.string().optional(),
    }),
  );

export const documentTextSchema = z.object({
  instanceId: z.preprocess(
    nullishToEmpty(''),
    z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
  ),
  normalizedQueryHash: z.preprocess(
    nullishToEmpty(''),
    z.string({ required_error: 'Normalized Query Hash' }).min(1, 'Normalized Query Hash'),
  ),
  xmSqlId: nullishAsUndefined(z.string().optional()),
});

export type SqlDetailSchema = z.infer<typeof sqlDetailSchema>;
export type ParameterDetailSchema = z.infer<typeof parameterDetailSchema>;
export type DocumentTextSchema = z.infer<typeof documentTextSchema>;

export type ClickhouseSqlDetailAddition = BaseSqlDetailAddition & SqlDetailSchema;
export type ClickhouseParameterDetailAddition = Omit<
  BaseParameterDetailAddition & ParameterDetailSchema,
  'parameterName'
>;
